// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"09da0da6","952":"ae5b2e8f"}[chunkId] + ".chunk.js";
};